/* Serenity — add-to-cart global.
   Botones [data-srn-add] (1 variante) y [data-srn-kit="id,id"] (varias).
   Agrega vía /cart/add.js y abre el drawer con la barra de envío-gratis.
   Fallback a /cart si no hay drawer. Delegación en document → funciona
   también con contenido re-renderizado (cross-sell dentro del drawer). */
(function () {
  var routes = window.routes || {};
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var cartUrl = routes.cart_url || '/cart';

  function busy(b, on) {
    if (on) { b.dataset.srnLabel = b.innerHTML; b.style.opacity = 0.6; b.style.pointerEvents = 'none'; }
    else { b.style.opacity = ''; b.style.pointerEvents = ''; }
  }

  function addAndOpen(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state && state.status) { throw new Error(state.description || 'cart error'); } // 422 sold out, etc.
      // Analytics (add_to_cart + Meta AddToCart) = fuente única en posthog-events.js,
      // que intercepta este mismo fetch('/cart/add') con data rica + dedup CAPI.
      // NO capturar aquí — duplicaba el evento.
      if (drawer && state && state.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      } else {
        window.location.href = cartUrl;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-srn-add]');
    var kit = e.target.closest('[data-srn-kit]');
    if (!add && !kit) return;
    e.preventDefault();
    var btn = add || kit;
    var items;
    if (add) {
      var id = add.getAttribute('data-srn-add');
      if (!id) return;
      var qty = parseInt(add.getAttribute('data-srn-qty') || '1', 10) || 1;
      items = [{ id: Number(id), quantity: qty }];
    } else {
      var ids = (kit.getAttribute('data-srn-kit') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    }
    busy(btn, true);
    addAndOpen(items).catch(function () { window.location.href = cartUrl; }).then(function () { busy(btn, false); });
  });

  // checkout_started + Meta InitiateCheckout = fuente única en posthog-events.js
  // (captura el click de checkout con datos del carrito). NO duplicar aquí.
})();
